// Mapping of ISO country codes to numeric dial codes
export const countryCodeToDialCode: Record<string, string> = {
  MX: '52',
  US: '1',
  CA: '1',
  BR: '55',
  AR: '54',
  CO: '57',
  CL: '56',
  PE: '51',
  EC: '593',
  BO: '591',
  PY: '595',
  UY: '598',
  VE: '58',
  CR: '506',
  PA: '507',
  DO: '1809',
  GT: '502',
  HN: '504',
  NI: '505',
  SV: '503',
  PR: '1787',
  ES: '34',
  FR: '33',
  DE: '49',
  IT: '39',
  GB: '44',
};
